import { cn } from "@omni/utils/styles/tw.merge";
import React from "react";

import { SpinnerVariants, SpinnerVariantsSize } from "./spinner.variants";

export type SpinnerComponentProps = {
    size?: SpinnerVariantsSize;
    className?: string;
    children?: React.ReactNode;
};

const Spinner = ({
    size = "md",
    className,
    children
}: SpinnerComponentProps) => {
    const classes = cn(
        SpinnerVariants[size],
        "tw:inline-block tw:animate-spin tw:align-[calc(--spacing(1)/-2)]",
        "tw:border-primary tw:border-r-transparent",
        "tw:rounded-[50%]",
        className
    );

    return (
        <output className={classes}>
            {children && <span className={cn("tw:sr-only")}>{children}</span>}
        </output>
    );
};

export { Spinner };
